import { extendTheme } from '@chakra-ui/react'
import { globalStyles } from './styles'
import { breakpoints } from './foundations/breakpoints'
import { colors } from './foundations/colors'
import { fonts } from './foundations/fonts'

import { Button } from './components/Button'
import { Badge } from './components/Badge'
import { Switch } from './components/Switch'
import { Checkbox } from './components/Checkbox'
import { Radio } from './components/Radio'
import { FormLabel } from './components/FormLabel'
import { Drawer } from './components/Drawer'
import { Input } from './components/Input'
import { Link } from './components/Link'
import { Menu } from './components/Menu'
import { Modal } from './components/Modal'
import { Popover } from './components/Popover'
import { Progress } from './components/Progress'
import { Text } from './components/Text'
import { Heading } from './components/Heading'
import { Table } from './components/Table'
import { Tabs } from './components/Tabs'
import { Skeleton } from './components/Skeleton'

import { OverlayComponent } from './additions/components/Overlay'
import { ButtonSwitchComponent } from './additions/components/ButtonSwitch'
import { ContentComponent } from './additions/layout/Content'
import { CardComponent } from './additions/layout/Card'

// import { mode } from "@chakra-ui/theme-tools";

export default extendTheme(
  {
    config: {
      cssVarPrefix: 'rt'
    }
  },
  { breakpoints },
  { colors },
  { fonts },
  globalStyles,
  {
    components: {
      Button,
      Badge,
      Switch,
      Checkbox,
      Radio,
      FormLabel,
      Drawer,
      Input,
      Select: Input,
      Link,
      Menu,
      Modal,
      Popover,
      Progress,
      Text,
      Heading,
      Table,
      Tabs,
      Skeleton
    }
  },

  OverlayComponent,
  ButtonSwitchComponent,
  ContentComponent,
  CardComponent
)
